<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__id><div class="table-default__left">Request</div></template>
      <template #h__employee><div class="table-default__left">Employee</div></template>
      <template #h__position><div class="table-default__left">Position</div></template>
      <template #h__reason><div class="table-default__left">Reason</div></template>
      <template #h__created><div class="table-default__left">Created by</div></template>
      <template #h__updated><div class="table-default__left">Updated by</div></template>
      <template #id="{ row }">
        <div class="table-default__left">Warning - #{{ row.id }}</div>
      </template>
      <template #employee="{ row }">
        <div class="table-default__left">
          <router-link
            :to="{ name: 'employees-profile', params: { id: row.employee.id } }"
            class="table-default__link-border"
          >
            {{ row.employee.full_name }}
          </router-link>
        </div>
      </template>
      <template #position="{ row }">
        <div class="table-default__left">{{ row.employee.position.name }}</div>
      </template>
      <template #penalty="{ row }">{{ row.penalty ? `${row.penalty.toLocaleString()} TSh` : '-' }}</template>
      <template #reason="{ row }">
        <div class="table-default__left">{{ row.reason }}</div>
      </template>
      <template #created="{ row }">
        <div class="table-default__left">
          <div v-if="row.created_by" class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
            {{ formatDateTime(row.created_at) }}
          </div>
        </div>
      </template>
      <template #updated="{ row }">
        <div class="table-default__left">
          <div v-if="row.updated_by" class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
            {{ formatDateTime(row.updated_at) }}
          </div>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records
        :all="pagination.count"
        :count="tableItems.length"
        :page="pagination.page"
      />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableLegalEntities',
  props: ['tableItems', 'pagination', 'tablePreloader', 'getUserAvatar', 'formatDateTime'],
  data() {
    return {
      table: {
        columns: ['id', 'employee', 'position', 'penalty', 'reason', 'created', 'updated'],
        options: {
          headings: {
            id: 'Request',
            employee: 'Employee',
            position: 'Position',
            penalty: 'Penalty',
            reason: 'Reason',
            created: 'Created by',
            updated: 'Updated by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
}
</script>
